var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:!_vm.plain ? 'box' : 'box_plain'},_vm._l((_vm.options),function(item,index){return _c('div',{key:index,staticClass:"box_item",class:_vm.valueKey
        ? _vm.boxValue.indexOf(item[_vm.valueKey]) === -1
          ? ''
          : 'is-active'
        : _vm.boxValue.indexOf(item) === -1
        ? ''
        : 'is-active',on:{"click":function($event){return _vm.boxClick(item)}}},[_vm._v(" "+_vm._s(item[_vm.labelKey])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }